<template>
  <span class="delete" @click="onDel">删除本条</span>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { resumeApi } from '@/api'

export default {
  props: {
    fixCon: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'resumeCon',
      'drafts'
    ])
  },
  methods: {
    ...mapMutations('resume', ['CHANGE_RESUME_CON', 'SET_FORM']),
    async onDel() {
      if (this.fixCon) {
        const { type, tem, idx } = this.fixCon
        console.log(type, tem, idx)
        this.CHANGE_RESUME_CON({
          type,
          tem: tem.template,
          idx
        })
        this.drafts[tem.type].splice(this.idx, 1)
        delete this.drafts.id
        delete this.drafts.uid
        await resumeApi.addDraft(this.drafts)
      }
      this.$emit('onDel')
    }

  }
}
</script>
